import React from 'react';
import { MessageCircle, Search, FileCheck } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: MessageCircle,
      title: 'Brand Introduction',
      description: 'Tell us about your business, your vision, and the trademark you want to secure. The more we know, the better we can protect what matters to you.'
    },
    {
      number: '02',
      icon: Search,
      title: 'Trademark Availability Check',
      description: 'Our legal experts run a detailed search across federal databases to confirm your trademark is unique and ready for registration.'
    },
    {
      number: '03',
      icon: FileCheck,
      title: 'Filing Made Easy',
      description: 'We draft, review, and file your trademark application with the USPTO—ensuring accuracy and increasing your chances of quick approval.'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Process
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Our Simple 3-Step Trademark Protection Process
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-50 rounded-xl p-8 h-full hover:shadow-lg transition-shadow duration-300">
                <div className="text-6xl font-bold text-[#FF6B35] opacity-20 mb-4">
                  {step.number}
                </div>
                <div className="w-16 h-16 bg-[#FF6B35] rounded-lg flex items-center justify-center mb-6">
                  <step.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-0.5 bg-[#FF6B35]"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessSection;